import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import styles from '../styles'

const NotificationCenterChatItemView = ({
  title,
  description,
  action,
  classes,
}) => {
  return (
    <ListItem
      button
      onClick={action}
      className={classnames(classes.flex, classes.wrapper)}
    >
      <ListItemIcon>
        <QuestionAnswerIcon />
      </ListItemIcon>
      <ListItemText
        className={classes.textWrapper}
        primary={title}
        secondary={description}
      />
      <NavigateNextIcon />
    </ListItem>
  )
}

export default injectStyles(styles)(NotificationCenterChatItemView)



// WEBPACK FOOTER //
// ./src/Components/NotificationCenter/blocks/NotificationCenterItem/variants/NotificationCenterChatItemView.js